import { render, staticRenderFns } from "./documents.pp36.vue?vue&type=template&id=59563839&scoped=true"
import script from "./documents.pp36.vue?vue&type=script&lang=js"
export * from "./documents.pp36.vue?vue&type=script&lang=js"
import style0 from "./documents.pp36.vue?vue&type=style&index=0&id=59563839&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59563839",
  null
  
)

export default component.exports